import { useMutation } from '@tanstack/react-query';

import * as services from 'services/product';

export const useMutationImportProduct = () => {
  const confirmImportProductViaSpreadSheet = useMutation({
    mutationFn: services.confirmImportProductViaSpreadSheet,
  });

  const confirmImportBulkEditProduct = useMutation({
    mutationFn: services.confirmImportBulkEditProduct,
  });

  return {
    confirmImportBulkEditProduct,
    confirmImportProductViaSpreadSheet,
  };
};
